import { render, staticRenderFns } from "./NgPhoneIso.vue?vue&type=template&id=a8a8605a"
import script from "./NgPhoneIso.vue?vue&type=script&lang=js"
export * from "./NgPhoneIso.vue?vue&type=script&lang=js"
import style0 from "./NgPhoneIso.vue?vue&type=style&index=0&id=a8a8605a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports